import { render } from "./PerfilAdmin.vue?vue&type=template&id=51c3b5aa&scoped=true"
import script from "./PerfilAdmin.vue?vue&type=script&lang=js"
export * from "./PerfilAdmin.vue?vue&type=script&lang=js"

import "./PerfilAdmin.vue?vue&type=style&index=0&id=51c3b5aa&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c3b5aa"]])

export default __exports__